import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import MyApiClient from '../../../../api-client/MyApiClient';
import { useNavigate } from 'react-router-dom';

import { conMotivo } from "../../Util/erroreServer";
import { segnalaMancanti } from "../../Util/campiMancanti";
export const FormPagamenti = (props) => {

	const formRef = useRef(null);
	const navigate = useNavigate();

	const [stripeEnabled, setStripeEnabled] = useState(false);
	const [bonificoEnabled, setBonificoEnabled] = useState(false);
	const [stripeKey, setStripeKey] = useState('');
	const [iban, setIban] = useState('');
	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
	const [verifying, setVerifying] = useState(false);
	const [verification, setVerification] = useState(null);

	const handleSaveClick = (e) => {
		e.preventDefault();

		const form = formRef.current;
		if (form) {

			const isValid = true;

			// Dati mancanti: niente finestra, si evidenziano i campi e il cursore va al primo (regola SUI)
			const mancanti = [];
			if (stripeEnabled && !(stripeKey ?? '').trim()) mancanti.push({ campo: 'stripe-key', messaggio: 'Manca la chiave privata di Stripe' });
			if (bonificoEnabled) {
				if (!iban) mancanti.push({ campo: 'bonifico-iban', messaggio: "Manca l'IBAN" });
				else if (iban.length !== 27) mancanti.push({ campo: 'bonifico-iban', messaggio: `L'IBAN deve avere 27 caratteri: ne hai scritti ${iban.length}` });
			}
			if (segnalaMancanti(mancanti) > 0) return;

			if (form.checkValidity() && isValid) {
				const saveData = async () => {
					try {
						const tokenDetailsString = sessionStorage.getItem('userDetails');
						if (tokenDetailsString) {
							const tokenDetails = JSON.parse(tokenDetailsString);
							const token = tokenDetails.idToken;
							const apiClient = new MyApiClient();
		
							let data_update = {
								club: {
									id: props.profile.club.id,
									paymentData: {
										stripe_enabled: stripeEnabled,
										bank_transfer_enabled: bonificoEnabled,
										stripe_api_key: stripeKey || undefined,
										bank_transfer_iban: iban || undefined,
									}
								} 
							};
		
							setLoadingShowed(true);
							const saveResult = await apiClient.updateProfile(token, data_update);
							setLoadingShowed(false);
		
							if (saveResult && saveResult.error) {
								setModalTitle("Errore durante l'operazione");
								setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
								setModalShowed(true);
							} else {
								navigate(0);
							}
						}
						setModalTitle("Errore durante l'operazione");
						setModalText(conMotivo("Si è verificato un errore durante il salvataggio."));
						setModalShowed(true);
					} catch (error) {
						console.error("Error fetching data:", error);
					}
				};
		
				saveData();
			} else {
				form.reportValidity();
			}
		}
	};

	const verificationVariant = () => {
		if (!verification) return 'secondary';
		if (!verification.valid) return 'danger';
		if (verification.chargesEnabled === false || verification.livemode === false) return 'warning';
		return 'success';
	};

	const handleVerifyClick = async () => {
		setVerification(null);

		const keyToVerify = (stripeKey ?? '').trim();
		if (!keyToVerify) {
			setVerification({ valid: false, message: 'Inserisci la chiave privata di Stripe prima di verificarla.' });
			return;
		}

		try {
			const tokenDetailsString = sessionStorage.getItem('userDetails');
			if (!tokenDetailsString) return;

			const token = JSON.parse(tokenDetailsString).idToken;
			const apiClient = new MyApiClient();

			setVerifying(true);
			const result = await apiClient.verifyClubStripeKey(token, keyToVerify);
			setVerifying(false);

			if (!result || result.error) {
				setVerification({ valid: false, message: result?.error ?? 'Verifica non riuscita.' });
				return;
			}

			setVerification(result);
		} catch (error) {
			console.error("Error verifying stripe key:", error);
			setVerifying(false);
			setVerification({ valid: false, message: 'Verifica non riuscita.' });
		}
	};

	// La chiave è cambiata: l'esito precedente non vale più.
	const handleStripeKeyChange = value => {
		setStripeKey(value);
		setVerification(null);
	};

	useEffect(() => {
		const paymentData = props.profile?.club?.paymentData;

		setStripeEnabled(!!paymentData?.stripe_enabled);
		setStripeKey(paymentData?.stripe_api_key ?? '');
		setBonificoEnabled(!!paymentData?.bank_transfer_enabled);
		setIban(paymentData?.bank_transfer_iban ?? '');
		setVerification(null);
	}, [props.profile]);
	
	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<Row className="align-items-start mt-4">
				<div className="col-xl-9">

					<Form ref={formRef} noValidate>
						<Card>
							<Card.Header>
								<h4 className="card-title">Integrazione con Stripe</h4>
							</Card.Header>
							<Card.Body>
								<Form.Check 
									type="switch"
									id="stripe-switch"
									className="sid-switch-grande"
									label="Abilita Stripe"
									checked={stripeEnabled}
									disabled={props.isDisabled}
									onChange={e => setStripeEnabled(e.target.checked)}
								/>
								{/* La chiave si chiede solo con lo switch acceso */}
								{stripeEnabled && (
								<Form.Group className="mt-4">
									<Form.Label htmlFor="stripe-key">Chiave privata di Stripe (verrà criptata sui nostri sistemi)</Form.Label>
									<Form.Control
										id="stripe-key"
										className="sid-campo-grande"
										required
										type="password"
										autoComplete="new-password"
										value={stripeKey ?? ''}
										name="stripeKey"
										onChange={e => handleStripeKeyChange(e.target.value)}
									/>
								</Form.Group>
								)}
								{stripeEnabled && (
									<div className="mt-3">
										<Button type="button" variant="outline-primary" onClick={handleVerifyClick} disabled={verifying}>
											{verifying
												? <><Spinner as="span" animation="border" size="sm" className="me-2" />Verifica in corso...</>
												: 'Verifica collegamento'}
										</Button>
									</div>
								)}
								{verification && (
									<Alert variant={verificationVariant()} className="solid mt-3" style={{color: 'black'}}>
										<strong>{verification.valid ? 'Chiave valida.' : 'Chiave non valida.'}</strong>{' '}
										{verification.message}
										{verification.accountName && (
											<div className="mt-2">Account Stripe: <strong>{verification.accountName}</strong></div>
										)}
										{verification.livemode === false && (
											<div className="mt-2">Attenzione: è una chiave di <strong>test</strong>, non incasserà pagamenti reali.</div>
										)}
									</Alert>
								)}
							</Card.Body>
						</Card>
						<Card>
							<Card.Header>
								<h4 className="card-title">Mostra IBAN in App per pagamenti bonifico</h4>
							</Card.Header>
							<Card.Body>
								<Form.Check 
									type="switch"
									id="bonifico-switch"
									className="sid-switch-grande"
									label="Abilita Bonifico"
									checked={bonificoEnabled}
									disabled={props.isDisabled}
									onChange={e => setBonificoEnabled(e.target.checked)}
								/>
								{/* L'IBAN si chiede solo con lo switch acceso */}
								{bonificoEnabled && (
								<Form.Group className="mt-4">
									<Form.Label htmlFor="bonifico-iban">IBAN</Form.Label>
									<Form.Control
										id="bonifico-iban"
										className="sid-campo-grande"
										required
										type="text"
										maxLength={34}
										value={iban ?? ''}
										name="iban"
										onChange={e => setIban(e.target.value.toUpperCase().replace(/\s/g, ''))}
									/>
								</Form.Group>
								)}
							</Card.Body>
						</Card>
					</Form>
					{!props.isDisabled && <div className="d-flex justify-content-end gap-4 mt-4"><Button type="button" onClick={handleSaveClick} className="btn btn-primary btn-add">Salva</Button></div>}
				</div>
				<div className="col-xl-3">
					<Card>
						<Card.Body className="text-left">
							Abilitando l’opzione "Abilita Stripe" nel backend, il sistema richiede di inserire la chiave privata del tuo account Stripe e mostrerà in App all'utente la possibilità di pagare i propri acquisti presso la tua struttura utilizzando la carta di credito, per i prodotti specifici per cui vorrai confermare l'abilitazione del pagamento tramite carta.
							<br></br><br></br>
							Abilitando l’opzione "Abilita Bonifico" nel backend, il sistema richiede di inserire l'IBAN del tuo conto bancario e mostrerà in App all'utente la possibilità di pagare i propri acquisti presso la tua struttura utilizzando il bonifico, per i prodotti specifici per cui vorrai confermare l'abilitazione del pagamento tramite bonifico.
						</Card.Body>
					</Card>
				</div>
			</Row>
		</>
	)
}
export default FormPagamenti;